<template>
    <div>
        <b-modal v-model="$store.state.showProfileForm" :title="$t('updateProfile')" @ok="profile" @show="showProfile" :no-close-on-backdrop="true" :no-enforce-focus="true">
            <div class="alert alert-info">
             <div>Link giới thiệu: https://client.callio.vn/register/{{profileModel._id}}</div>
              <div v-if="$store.state.user.role === 'agency'">Khách hàng đăng ký bằng link này sẽ tự động được gắn vào đại lý của bạn</div>
              <div v-else>Khách hàng đăng ký bằng link này sẽ tự động nhận bạn làm nhân viên Sales</div>
            </div>
            <form-input :label="$t('name')" :model="profileModel" type="text" attribute="name" :errors="errors"></form-input>
            <form-input :label="$t('phone')" :model="profileModel" type="text" attribute="phone" :errors="errors"></form-input>
            <form-file :label="$t('avatar')" service="/upload/upload-image" :model="profileModel" attribute="avatar" :errors="errors" accept="image/jpeg,image/jpg" />
            <form-textarea :label="$t('desc')" :model="profileModel" attribute="desc" :errors="errors"></form-textarea>
        </b-modal>
        <b-modal v-model="$store.state.showPasswordForm" :title="$t('changePassword')" @ok="password" :no-close-on-backdrop="true" :no-enforce-focus="true">
            <form-input :label="$t('oldPassword')" type="password" :model="passwordModel" attribute="oldPassword" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
            <form-input :label="$t('password')" type="password" :model="passwordModel" attribute="password" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
            <form-input :label="$t('rePassword')" type="password" :model="passwordModel" attribute="rePassword" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                profileModel: {},
                passwordModel: {},
                errors: {},
            };
        },

        i18n: {
            messages: {
                en: {
                    updateProfile: 'Update profile',
                    changePassword: 'Change password',
                    name: 'Your name',
                    phone: 'Phone',
                    avatar: 'Avatar',
                    desc: 'About you',
                    oldPassword: 'Current password',
                    password: 'New password',
                    rePassword: 'Confirm new password',
                    passwordPlaceholder: 'Password',
                    success: 'Success',
                    error: 'Error',
                    profileUpdated: 'Your profile has been updated successfully!',
                    profileUpdateFailed: 'Cannot update your profile now, please try again!',
                    passwordUpdated: 'Your password has been updated successfully!',
                    passwordUpdateFailed: 'Cannot update your password now, please try again!'
                },
                vi: {
                    updateProfile: 'Cập nhật hồ sơ',
                    changePassword: 'Đổi mật khẩu',
                    name: 'Tên của bạn',
                    phone: 'Số điện thoại',
                    avatar: 'Hình đại diện',
                    desc: 'Giới thiệu bản thân',
                    oldPassword: 'Mật khẩu hiện tại',
                    password: 'Mật khẩu mới',
                    rePassword: 'Xác nhận mật khẩu',
                    passwordPlaceholder: 'Mật khẩu',
                    success: 'Thành công',
                    error: 'Có lỗi',
                    profileUpdated: 'Hồ sơ cá nhân của bạn đã được cập nhật thành công!',
                    profileUpdateFailed: 'Hiện không thể cập nhật hồ sơ cá nhân của bạn, xin thử lại sau!',
                    passwordUpdated: 'Mật khẩu của bạn đã được cập nhật thành công!',
                    passwordUpdateFailed: 'Hiện không thể thay đổi mật khẩu của bạn, xin thử lại sau!'
                }
            }
        },
        methods: {
            showProfile: function () {
                let loader = this.$loading.show();
                this.$service.get('/profile').then(response => {
                    this.profileModel = response.data;
                }).finally(() => {
                    loader.hide();
                });
            },
            profile: function (evt) {
                evt.preventDefault();
                let loader = this.$loading.show();
                this.errors = {};
                if (this.profileModel.avatar && this.profileModel.avatar[0]) {
                    this.profileModel.avatar = this.profileModel.avatar[0].url;
                }
                this.$service.put('/profile', this.profileModel).then(response => {
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('profileUpdated'),
                            icon: 'success'
                        });
                        this.$store.commit('user', response.data);
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t('profileUpdateFailed'),
                            icon: 'error'
                        });
                    }
                    this.$store.commit('showProfileForm', false);
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    loader.hide();
                });
            },
            password: function (evt) {
                evt.preventDefault();
                let loader = this.$loading.show();
                this.errors = {};
                this.$service.put('/profile/password', this.passwordModel).then(response => {
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('passwordUpdated'),
                            icon: 'success'
                        });
                        sessionStorage.removeItem('token');
                        localStorage.removeItem('token');
                        this.$service.defaults.headers.common['token'] = null;
                        this.$bgService.defaults.headers.common['token'] = null;
                        this.$store.commit('user', null);
                        this.$router.push('/login');
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t('passwordUpdateFailed'),
                            icon: 'error'
                        });
                    }
                    this.passwordModel = {};
                    this.$store.commit('showPasswordForm', false);
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    loader.hide();
                });
            }
        },
    };
</script>